<template>
<div>
  <top-navigation></top-navigation>
  <vue-headful
    :title=contentPage.metaTitle
    :description=contentPage.metaDescription
    :keywords=contentPage.metaKeywords
  />
  <div>
    <div class="container">
      <div class="row">
        <left-sidebar :showProductCategoryNavigation=true></left-sidebar>
        <div class="col-sm-9 padding-right content-page">
          <h2>{{ contentPage.pageTitle }}</h2>
          <div v-html="contentPage.pageText"/>
          <email-form v-if="contentPage.pageType==='EmailForm'" :pageType=contentPage.pageType></email-form>
          <email-form v-if="contentPage.pageType==='NewsletterForm'" :pageType=contentPage.pageType></email-form>
          <br/><br/>
          <div v-if="contentPage.pageType=='Contact'" v-html="contentPage.additionalContent"></div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import TopNavigation from '../../components/common/TopNavigation';
import LeftSidebar from '../../components/common/LeftSidebar';
import EmailForm from '../../components/content/EmailForm';

export default {
  name: 'home',
  created() {
    if (this.contentPage.length === 0 || this.currentPage !== this.contentSlug) {
      this.$store.dispatch('getContent', this.contentSlug);
    }
  },
  updated() {
    const descEl = document.querySelector('head meta[name="description"]');
    const keywordsEl = document.querySelector('head meta[name="keywords"]');
    const titleMetaEl = document.querySelector('head meta[name="title"]');
    const titleEl = document.querySelector('head title');
    keywordsEl.setAttribute('content', `${this.contentPage.pageKeywords}, ${keywordsEl.getAttribute('content')}`);
    titleMetaEl.setAttribute('content', `${this.contentPage.pageTitle}`);
    descEl.setAttribute('content', this.contentPage.pageDescription);
    titleEl.textContent = `${this.contentPage.pageTitle}`;
  },
  watch: {
    /* eslint no-unused-vars: [2, { "args": "none" }] */
    $route(to, from) {
      if (this.currentPage !== this.contentSlug) {
        this.$store.dispatch('getContent', this.contentSlug);
      }
    },
  },
  computed: {
    contentSlug() {
      return this.$route.params.contentSlug;
    },
    contentPage() {
      return this.$store.getters.getContent;
    },
    currentPage() {
      return this.$store.getters.getCurrentPage;
    },
  },
  components: {
    'top-navigation': TopNavigation,
    'left-sidebar': LeftSidebar,
    'email-form': EmailForm,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/content/Index.vue